var _rect, _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 280,
    viewBox: "0 0 352 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 50.002,
    width: 352,
    height: 229,
    rx: 17.3297,
    fill: "#FDEFE6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.0455,
    y: 23.4414,
    width: 176.907,
    height: 157.805,
    rx: 4.7591,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 32.96,
    width: 109.033,
    height: 7.94278,
    rx: 3.97139,
    fill: "#1F273D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 49.0586,
    width: 109.033,
    height: 42.6022,
    rx: 5.77657,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 99.8174,
    width: 109.033,
    height: 7.94278,
    rx: 3.97139,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 115.916,
    width: 109.033,
    height: 7.94278,
    rx: 3.97139,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 132.015,
    width: 73.6512,
    height: 7.94278,
    rx: 3.97139,
    fill: "#EEEEEE"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.973 157.411C112.745 157.757 112.84 158.221 113.185 158.45L116.78 160.827C116.733 160.894 116.685 160.962 116.636 161.031L112.244 158.126C111.899 157.897 111.434 157.992 111.205 158.337C110.977 158.682 111.072 159.147 111.417 159.375L115.787 162.266C115.743 162.332 115.699 162.399 115.655 162.465L112.257 160.217C111.911 159.988 111.447 160.083 111.218 160.428C110.99 160.773 111.085 161.238 111.43 161.466L114.856 163.732C114.816 163.799 114.779 163.864 114.743 163.927L113.093 162.836C112.818 162.654 112.448 162.729 112.266 163.005C112.084 163.28 112.159 163.65 112.434 163.832L114.417 165.144C114.869 165.544 115.881 166 116.534 166.29C119.316 167.529 121.08 165.722 121.756 164.568C122.432 163.415 121.981 161.541 121.135 160.314C120.458 159.332 120.075 157.794 120.141 157.056C120.119 156.964 120.105 156.884 120.093 156.814C120.035 156.492 120.018 156.397 119.435 156.356C118.725 156.307 118.021 157.493 118.351 158.405C118.615 159.134 117.975 159.485 117.689 159.566L117.656 159.61L114.012 157.2C113.667 156.972 113.202 157.066 112.973 157.411Z",
    fill: "#F5B95C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.487 157.747C115.205 157.445 115.222 156.97 115.524 156.688C115.827 156.406 116.301 156.423 116.583 156.726L119.562 159.924L119.605 159.888C119.902 159.876 120.607 159.684 120.521 158.914C120.414 157.95 121.376 156.962 122.054 157.176C122.612 157.352 122.606 157.449 122.587 157.775C122.582 157.846 122.578 157.927 122.578 158.022C122.34 158.723 122.352 160.309 122.78 161.422C123.316 162.814 123.316 164.74 122.388 165.704C121.46 166.667 119.322 168.01 116.908 166.155C116.342 165.72 115.467 165.042 115.12 164.547L113.497 162.805C113.272 162.563 113.285 162.185 113.527 161.961C113.768 161.736 114.146 161.749 114.371 161.99L115.697 163.414C115.709 163.356 115.733 163.276 115.78 163.173L113.075 160.269C112.793 159.966 112.81 159.492 113.112 159.21C113.415 158.928 113.889 158.945 114.171 159.248L116.704 161.966C116.757 161.912 116.813 161.855 116.872 161.798L113.552 158.233C113.27 157.93 113.286 157.456 113.589 157.174C113.892 156.892 114.366 156.909 114.648 157.212L118.024 160.835C118.096 160.786 118.167 160.741 118.236 160.698L115.487 157.747Z",
    fill: "#F8D153"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.174 165.583C137.574 165.583 138.601 164.549 138.601 163.142C138.601 161.717 137.61 160.672 136.26 160.672C135.765 160.672 135.284 160.848 134.982 161.088H134.939L135.198 158.92H138.271V158.13H134.451L134.006 161.749L134.839 161.85C135.144 161.631 135.664 161.473 136.117 161.476C137.054 161.483 137.739 162.194 137.739 163.156C137.739 164.1 137.079 164.793 136.174 164.793C135.42 164.793 134.821 164.309 134.753 163.644H133.891C133.945 164.764 134.91 165.583 136.174 165.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.976 164.133C148.848 164.133 149.555 163.425 149.555 162.553C149.555 161.681 148.848 160.974 147.976 160.974C147.104 160.974 146.396 161.681 146.396 162.553C146.396 163.425 147.104 164.133 147.976 164.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.254 154.548C159.129 154.548 156.596 157.081 156.596 160.206C156.596 162.394 157.837 164.291 159.654 165.233L160.132 168.692L164.438 165.864H165.083C168.207 165.864 170.741 163.331 170.741 160.206C170.741 157.081 168.207 154.548 165.083 154.548H162.254Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.654 165.233L160.37 165.134L160.319 164.764L159.987 164.592L159.654 165.233ZM160.132 168.692L159.417 168.791L159.573 169.923L160.528 169.296L160.132 168.692ZM164.438 165.864V165.142H164.222L164.042 165.26L164.438 165.864ZM157.318 160.206C157.318 157.48 159.528 155.27 162.254 155.27V153.826C158.73 153.826 155.874 156.682 155.874 160.206H157.318ZM159.987 164.592C158.4 163.769 157.318 162.113 157.318 160.206H155.874C155.874 162.674 157.275 164.813 159.322 165.874L159.987 164.592ZM160.847 168.594L160.37 165.134L158.939 165.332L159.417 168.791L160.847 168.594ZM164.042 165.26L159.736 168.089L160.528 169.296L164.835 166.467L164.042 165.26ZM165.083 165.142H164.438V166.586H165.083V165.142ZM170.019 160.206C170.019 162.932 167.809 165.142 165.083 165.142V166.586C168.606 166.586 171.463 163.729 171.463 160.206H170.019ZM165.083 155.27C167.809 155.27 170.019 157.48 170.019 160.206H171.463C171.463 156.682 168.606 153.826 165.083 153.826V155.27ZM162.254 155.27H165.083V153.826H162.254V155.27Z",
    fill: "#C6C2C2",
    mask: "url(#path-14-inside-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.145 163.975H180.606V165.482H181.453V163.975H182.458V163.185H181.453V158.13H180.376L177.145 163.242V163.975ZM180.606 163.185H178.108V163.127L180.549 159.265H180.606V163.185ZM186.288 165.583C187.713 165.583 188.772 164.689 188.772 163.486C188.772 162.553 188.219 161.875 187.293 161.72V161.663C188.036 161.437 188.499 160.826 188.499 159.997C188.499 158.956 187.677 158.03 186.317 158.03C185.046 158.03 183.99 158.812 183.947 159.968H184.809C184.841 159.236 185.538 158.805 186.302 158.805C187.114 158.805 187.638 159.297 187.638 160.04C187.638 160.816 187.031 161.318 186.159 161.318H185.57V162.108H186.159C187.275 162.108 187.896 162.675 187.896 163.486C187.896 164.265 187.218 164.793 186.274 164.793C185.423 164.793 184.748 164.355 184.694 163.644H183.789C183.843 164.8 184.863 165.583 186.288 165.583ZM195.338 165.597C196.558 165.597 197.363 164.851 197.506 163.874H196.659C196.501 164.477 195.998 164.836 195.338 164.836C194.333 164.836 193.687 164.003 193.687 162.725C193.687 161.476 194.347 160.658 195.338 160.658C196.085 160.658 196.53 161.117 196.659 161.62H197.506C197.363 160.586 196.487 159.897 195.323 159.897C193.83 159.897 192.839 161.074 192.839 162.754C192.839 164.405 193.787 165.597 195.338 165.597ZM200.985 165.597C202.478 165.597 203.483 164.463 203.483 162.754C203.483 161.031 202.478 159.897 200.985 159.897C199.491 159.897 198.486 161.031 198.486 162.754C198.486 164.463 199.491 165.597 200.985 165.597ZM200.985 164.836C199.85 164.836 199.333 163.86 199.333 162.754C199.333 161.648 199.85 160.658 200.985 160.658C202.119 160.658 202.636 161.648 202.636 162.754C202.636 163.86 202.119 164.836 200.985 164.836ZM204.776 165.482H205.624V162.036C205.624 161.228 206.212 160.658 206.873 160.658C207.515 160.658 207.964 161.078 207.964 161.706V165.482H208.826V161.893C208.826 161.182 209.271 160.658 210.046 160.658C210.649 160.658 211.166 160.977 211.166 161.792V165.482H212.014V161.792C212.014 160.496 211.317 159.897 210.334 159.897C209.544 159.897 208.966 160.259 208.682 160.83H208.625C208.352 160.241 207.871 159.897 207.146 159.897C206.428 159.897 205.896 160.241 205.667 160.83H205.595V159.968H204.776V165.482ZM213.563 165.482H214.41V162.036C214.41 161.228 214.999 160.658 215.659 160.658C216.302 160.658 216.75 161.078 216.75 161.706V165.482H217.612V161.893C217.612 161.182 218.057 160.658 218.832 160.658C219.436 160.658 219.952 160.977 219.952 161.792V165.482H220.8V161.792C220.8 160.496 220.103 159.897 219.12 159.897C218.33 159.897 217.752 160.259 217.468 160.83H217.411C217.138 160.241 216.657 159.897 215.932 159.897C215.214 159.897 214.683 160.241 214.453 160.83H214.381V159.968H213.563V165.482ZM224.661 165.597C225.781 165.597 226.599 165.037 226.858 164.204L226.039 163.975C225.824 164.549 225.325 164.836 224.661 164.836C223.666 164.836 222.981 164.194 222.941 163.013H226.944V162.654C226.944 160.6 225.723 159.897 224.574 159.897C223.081 159.897 222.09 161.074 222.09 162.769C222.09 164.463 223.067 165.597 224.661 165.597ZM222.941 162.28C222.998 161.422 223.605 160.658 224.574 160.658C225.493 160.658 226.082 161.347 226.082 162.28H222.941ZM229.08 162.165C229.08 161.203 229.676 160.658 230.487 160.658C231.273 160.658 231.751 161.171 231.751 162.036V165.482H232.598V161.979C232.598 160.572 231.847 159.897 230.731 159.897C229.898 159.897 229.381 160.27 229.123 160.83H229.051V159.968H228.232V165.482H229.08V162.165ZM236.544 159.968H235.366V158.647H234.519V159.968H233.686V160.686H234.519V164.133C234.519 165.095 235.295 165.554 236.013 165.554C236.328 165.554 236.529 165.497 236.644 165.454L236.472 164.693C236.4 164.707 236.285 164.736 236.099 164.736C235.725 164.736 235.366 164.621 235.366 163.903V160.686H236.544V159.968ZM241.625 161.203C241.36 160.421 240.764 159.897 239.672 159.897C238.509 159.897 237.648 160.557 237.648 161.491C237.648 162.252 238.1 162.761 239.112 162.998L240.031 163.214C240.588 163.343 240.85 163.609 240.85 163.989C240.85 164.463 240.347 164.851 239.558 164.851C238.865 164.851 238.43 164.553 238.28 163.96L237.475 164.161C237.673 165.098 238.445 165.597 239.572 165.597C240.853 165.597 241.726 164.897 241.726 163.946C241.726 163.178 241.245 162.693 240.261 162.453L239.443 162.252C238.789 162.09 238.495 161.871 238.495 161.447C238.495 160.974 238.997 160.629 239.672 160.629C240.412 160.629 240.717 161.038 240.864 161.419L241.625 161.203Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.0455,
    y: 203.959,
    width: 176.907,
    height: 157.805,
    rx: 4.7591,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 213.478,
    width: 109.033,
    height: 7.94278,
    rx: 3.97139,
    fill: "#1F273D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.983,
    y: 229.576,
    width: 109.033,
    height: 42.6022,
    rx: 5.77657,
    fill: "#EEEEEE"
  })))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5925 18.6445L61.8514 10.9895L65.3236 23.1276L57.013 33.2293L48.5925 18.6445Z",
    fill: "#FFFF4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.846 0L310.849 7.12396L304.549 8.10184L300.009 3.30367L307.846 0Z",
    fill: "#FC2969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2211 258.352L66.2177 265.476L72.5176 266.453L77.0574 261.655L69.2211 258.352Z",
    fill: "#FC2969"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1642 212.615L92.7249 212.286L82.702 223.073L71.6107 220.101L79.1642 212.615Z",
    fill: "#2C79FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.294 94.8389L261.089 102.769L251.397 100.487L249.365 92.901L256.294 94.8389Z",
    fill: "#FFB251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 78.8248,
    y: 19.1951,
    width: 191.349,
    height: 172.247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.97444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.61035
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 110.737,
    y: 156.354,
    width: 11.3466,
    height: 11.0399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.343843,
    dy: 0.687687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.687687
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii",
    x: 111.498,
    y: 155.456,
    width: 13.0197,
    height: 14.0331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.03153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.687687
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.343843,
    dy: -1.03153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.687687
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.598275 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.687687,
    dy: 0.687687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37537
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.6 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 78.8248,
    y: 199.713,
    width: 191.349,
    height: 172.247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.97444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.61035
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 270,
    fill: "white",
    transform: "translate(42 9.00195)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.0455,
    y: 23.4414,
    width: 176.907,
    height: 157.805,
    rx: 4.7591,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.364,
    height: 106.998,
    fill: "white",
    transform: "translate(79.3171 32.96)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.364,
    height: 106.998,
    fill: "white",
    transform: "translate(79.3171 32.96)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.364,
    height: 106.998,
    fill: "white",
    transform: "translate(79.3171 32.96)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.033,
    height: 106.998,
    fill: "white",
    transform: "translate(119.983 32.96)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.033,
    height: 106.998,
    fill: "white",
    transform: "translate(119.983 32.96)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4414,
    height: 14.4414,
    fill: "white",
    transform: "translate(109.661 154.399)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.0455,
    y: 203.959,
    width: 176.907,
    height: 157.805,
    rx: 4.7591,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.364,
    height: 106.998,
    fill: "white",
    transform: "translate(79.3171 213.478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.364,
    height: 106.998,
    fill: "white",
    transform: "translate(79.3171 213.478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.364,
    height: 106.998,
    fill: "white",
    transform: "translate(79.3171 213.478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.033,
    height: 106.998,
    fill: "white",
    transform: "translate(119.983 213.478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.033,
    height: 106.998,
    fill: "white",
    transform: "translate(119.983 213.478)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementEmptyState);
export default __webpack_public_path__ + "static/media/announcement-empty-state.53c15bbf8c4ba9e4fff8dda40822428b.svg";
export { ForwardRef as ReactComponent };